import InboomaBaseModel from './InboomaBaseModel'
import { _,moment } from '../../vendor'
import { FormatHelper } from '../utils'
import InboomaBaseView from '../views/InboomaBaseView'

export default InboomaBaseModel.extend({

    urlRoot : '/reservations',

    _timeFilter : [
      'begin',
      'end',
      'blocked_begin',
      'blocked_end'
    ],

    initialize () {
        // again, we have to re-map what has not been done
        // yet on API side :( #whatCouldPossiblyGoWrong
        if (typeof this.get('contingents')[0] != 'undefined' && this.get('id') != '') {
          this.set('amount', this.get('contingents')[0]._joinData.amount);
        }

        InboomaBaseModel.prototype.initialize.apply(this);
    },

    validate (attr, options) {

        let begin, end;

        if (_.isNull(attr.begin) || attr.begin == '') {
          return 'reservation_error_missing_begin';
        }

        if (_.isNull(attr.end) || attr.end == '') {
          return 'reservation_error_missing_end';
        }

        if (moment(attr.begin).isValid() && moment(attr.end).isValid()) {
            // ISO 1806
            begin = moment(attr.begin);
            end = moment(attr.end);
        } else if (moment(attr.begin, 'D. MMMM YYYY').isValid() && moment(attr.end, 'D. MMMM YYYY').isValid()) {
            // D. MMMM YYYY
            begin = moment(attr.begin, 'D. MMMM YYYY');
            end = moment(attr.end, 'D. MMMM YYYY');
        } else if (moment(attr.begin, 'D. MMMM YYYY HH:mm').isValid() && moment(attr.end, 'D. MMMM YYYY HH:mm').isValid()) {
            // D. MMMM YYYY HH:mm
            begin = moment(attr.begin, 'D. MMMM YYYY HH:mm');
            end = moment(attr.end, 'D. MMMM YYYY HH:mm');
        } else {
            return 'invalid_time_format';
        }

        /** @todo Check for resourcetype_id === 4 (appointment) and then go into the if below
         *  This has a ticket: https://support.inbooma.net/issues/19324
        *if (typeof attr.summedContingents === 'undefined' && (typeof attr.event_id === 'undefined' || attr.event_id === '' || attr.event_id === null)) {
            return 'reservation_error_missing_appointment';
        }*/

        // @todo Warning: attr.resourcetype_id can be undefined when id == ''
        if (begin.format('X') > end.format('X') || (attr.resourcetype_id !== 4 && begin.format('X') == end.format('X'))) {
            return 'reservation_error_start_bigger_than_end';
        }
    
    },

    /**
     * Iterate through reservation, create a comma-separated list of all booked contingents
     * 
     * @param {String} memo Just pass '' if not called via _.reduce
     * @param {Backbone.Model} reservation instanceof Reservation
     * @return {String}
     */
    printContingentsAmountList (memo, reservation) {

        let r = ' ';

        // Fallback: Reservation was just created in this session so contingent._joinData is missing,
        // receive it from summedContingents
        _.each(reservation.get('summedContingents'), function (contingents) {
        
            if (typeof contingents.models[0] != 'undefined') {
                let size = FormatHelper.formatContingentTags(contingents.models[0].get('tags'));
                r = r + ((memo !== '' || r !== ' ') ? ', ' : '') + `${contingents.models[0].get('name')}${size} x ${contingents.length}`;
            }
        });

        if (r !== null && r !== ' ') {
            return memo + r;
        }

        if (typeof reservation.get('contingents')[0] === 'undefined') {
            return memo;
        }

        let amountPerContingent = {};

        if (typeof reservation.get('contingents_reservations') !== 'undefined' && reservation.get('contingents_reservations').length >= 1) {
            // Client-7 reservations (where reservation.contingents_reservations holds the acutal amount,
            // however reservation.contingents has the contingent information)

            _.each(reservation.get('contingents_reservations'), function(contingent) {
                // Get amount per contingent
                if (typeof amountPerContingent[contingent.contingent_id] === 'undefined') {
                    amountPerContingent[contingent.contingent_id] = contingent.amount;
                } else {
                    amountPerContingent[contingent.contingent_id] += contingent.amount;
                }
            });

            _.each(amountPerContingent, function(amount, contingent_id) {
                // Get contingent data from contingents array

                let full_contingent = _.filter(reservation.get('contingents'), function(contingent) {
                  return Number(contingent.id) === Number(contingent_id);
                })[0];
                
                if (typeof full_contingent !== 'undefined') {

                  let contingentDeleted = '';
                  
                  if (typeof full_contingent.deleted !== 'undefined'
                  && full_contingent.deleted !== null
                  && full_contingent.deleted !== '') {
                        contingentDeleted = ' (' + InboomaBaseView.prototype.t('removed_${a}', {a:InboomaBaseView.prototype.t('contingent')}) + ')';
                        reservation.set('_has_any_deleted_item', true);
                  }
                                
                  const size = FormatHelper.formatContingentTags(full_contingent.tags);

                  r += (r !== ' ' || memo !== '' ? ', ' : '') + full_contingent.name + size + contingentDeleted + ' x ' + amount;
                
                }

            });

        } else {

            // Regular (e.g. not-client-7) reservation
            _.each(reservation.get('contingents'), function(contingent) {
                if (typeof contingent._joinData === 'undefined') return;
                r += (r !== ' ' || memo !== '' ? ', ' : '') + contingent.name + ' x ' + contingent._joinData.amount;
            });
        }

        return memo + r;
    },

    defaults : {
      id : "",
      begin : "",
      end : "",
      blocked_begin: "",
      blocked_end: "",
      contingents : [],
      checkins : [],
      products: [],
      order: {},
      status : "requested", // [requested, confirmed inprogress, completed, cancelled]
      description : "",
      appointment_id : "",
      begin_location: "",
      end_location: "",
      internal_note : "", 
      external_note : "",
      manual_override : false,
      amount : "1",
      discount : "0",
      order_id : "",
      created : "",
      modified : "",
      _booking_time_differs : false,
    },

    _rbac : {
        "admin" : {
            "read" : true,
            "write" : true,
            "edit" : true,
            "edit-status" : true,
            "remove" : true,
            "order_export_contract" : true,
            "filter_by_location" : true,
            "filter_by_contingent" : true,
            "filter_by_network" : true,
            "filter_by_tag" : true,
            "viewReservationsList" : true,
            "viewOrders" : true
        },
        "user" : {
            "read" : true,
            "write" : false,
            "edit" : false,
            "edit-status" : false,
            "remove" : false,
            "order_export_contract" : false,
            "filter_by_contingent" : false,
            "filter_by_tag" : false,
            "viewReservationsList" : false,
            "viewOrders" : true
        },
        "manager" : {
            "read" : true,
            "write" : true,
            "edit" : true,
            "edit-status" : true,
            "remove" : true,
            "order_export_contract" : true,
            "filter_by_location" : true,
            "filter_by_contingent" : true,
            "filter_by_network" : true,
            "filter_by_tag" : true,
            "viewReservationsList" : true,
            "viewOrders" : true
        },
        "booking-manager" : {
            "read" : true,
            "write" : true,
            "edit" : true,
            "edit-status" : true,
            "remove" : true,
            "order_export_contract" : true,
            "filter_by_location" : false,
            "filter_by_contingent" : true,
            "filter_by_network" : false,
            "filter_by_tag" : false,
            "viewReservationsList" : true,
            "viewOrders" : true
        },
        "manager-location" : {
          "read" : true,
          "write" : true,
          "edit" : true,
          "edit-status" : true,
          "remove" : true,
          "order_export_contract" : true,
          "filter_by_location" : true,
          "filter_by_contingent" : true,
          "filter_by_tag" : true,
          "viewReservationsList" : true,
          "viewOrders" : true
        },
        "mediator" : {
            "read" : true,
            "write" : true,
            "edit" : true,
            "edit-status" : true,
            "remove" : true,
            "order_export_contract" : true,
            "filter_by_location" : true,
            "filter_by_contingent" : true,
            "filter_by_tag" : true,
            "viewReservationsList" : true,
            "viewOrders" : true
        },
        "garage-staff" : {
            "read" : true,
            "write" : false,
            "edit" : false,
            "edit-status" : false,
            "remove" : false,
            "order_export_contract" : false,
            "filter_by_location" : false,
            "filter_by_contingent" : false,
            "filter_by_tag" : false,
            "viewReservationsList" : true,
            "viewOrders" : true
        },
        "guide" : {
            "read" : true,
            "write" : false,
            "edit" : false,
            "edit-status" : false,
            "remove" : false,
            "order_export_contract" : false,
            "filter_by_location" : true,
            "filter_by_contingent" : false,
            "filter_by_tag" : false,
            "viewReservationsList" : true,
            "viewOrders" : true
        }
    }
});
